module.exports = __webpack_public_path__ + "static/media/sql.19d2daac.jpg";